import { render, staticRenderFns } from "./UpdateFamily.vue?vue&type=template&id=10de88ea&"
import script from "./UpdateFamily.vue?vue&type=script&lang=js&"
export * from "./UpdateFamily.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports